export default "__VITE_ASSET__Cyse1L7d__"